module.exports = __webpack_public_path__ + "img/tokuten_ico4.5710705a.png";